module.exports = __webpack_public_path__ + "media/images/emblems/Pfyn-58bb20356e9b7a50d4299ee0f8459412.gif";